import { render, staticRenderFns } from "./factories.vue?vue&type=template&id=3e6dc82a"
import script from "./factories.vue?vue&type=script&lang=js"
export * from "./factories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports